module.exports = __webpack_public_path__ + "img/reportclosure-yellow.1f73435e.svg";